<template>
  <div>
    <div class="col-md-10 col-md-offset-1 pd-mobile-10">
      <transition name="fade">
        <div v-if="!reviewedSitecode">
          <SiteSelection type="Registration" ref="SiteSelection">
          </SiteSelection>
        </div>
      </transition>
      <transition name="fade">
        <div v-show="reviewedSitecode" class="row" >
          <div class="col-md-12 general-inactive-section" :class="externalIDClass">
            <div class="row">
              <div class="col-md-10 col-md-offset-1">
                <div class="form-group">
                  <label
                    class="control-label required"
                    for="Employee/StudentID"
                  >
                    {{computeCaption(fields_en['employee_studentid'], $store.state.lang.value.toLowerCase())}}
                  </label>
                  <input
                    id="Employee/StudentID"
                    class="form-control"
                    type="text"
                    data-vv-as="Employee/Student ID"
                    v-validate="modelValidations.externalID"
                    v-model="model.externalID"
                    placeholder="ex: 123456"
                    name="externalID"
                    ref="externalID"
                    onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
                  />
                  <small class="text-danger" v-show="externalID.invalid">
                    {{getError("externalID", "First") && computeCaption(getError("externalID", "First"), $store.state.lang.value.toLowerCase())}}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="reviewedSitecode ">
          <GeneticsSection ref="GeneticsSection" :configuration="geneticsObject" :triggerGeneticsWatch="true"></GeneticsSection>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="reviewedSitecode ">
          <ScanningModule ref="scanningModule"></ScanningModule>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="reviewedSitecode">
          <questions-section ref="questionSection" section="main"></questions-section>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="reviewedSitecode ">
          <ConsentDisclaimer
            :submit="submit"
            :inline_disclaimer_and_consent="false"
            :allow_separate_signature="false"
            :allow_consent="false"
            ref="ConsentDisclaimer" />
        </div>
      </transition>
      <p class="text-danger text-center" v-show="error" style="padding-bottom: 10px;">
        {{error && computeCaption(error, $store.state.lang.value.toLowerCase())}}
      </p>
      <div class="row mt-10">
        <div class="col-md-10 col-md-offset-1 button-container">
          <button v-if="reviewedSitecode "
                  class="btn btn-fill btn-wd btn-next float-right next-button"
                  v-on:click.stop.prevent="callValidation()"
                  :disabled="disabledButton === true"
          >
            <span v-if="disabledButton === false">{{computeCaption(fields_en['submit_order'], $store.state.lang.value.toLowerCase())}}</span>
            <span v-else> {{computeCaption(fields_en['submitting'], $store.state.lang.value.toLowerCase())}}</span>
          </button>
          <button v-if="!reviewedSitecode"
                  class="btn btn-fill btn-wd btn-next float-right next-button"
                  v-on:click.stop.prevent="callSiteValidation()"
                  :disabled="disabledButton === true"
          >
            <span v-if="disabledButton === false"> {{computeCaption(fields_en['next'], $store.state.lang.value.toLowerCase())}}</span>
            <span v-else> {{computeCaption(fields_en['submitting'], $store.state.lang.value.toLowerCase())}}</span>
          </button>
        </div>
      </div>
      <br /><br />
    </div>
  </div>
</template>
<script>
import {mapFields} from 'vee-validate'
import {Autocomplete, Input, Drawer, Button, RadioGroup, Radio, RadioButton, DatePicker, CheckboxGroup, CheckboxButton} from 'element-ui'
import {FormatterUtils} from '../../../../utils/Formatter.js'
import {ValidationUtils} from '../../../../utils/Validation.js'
import axios from 'axios'
import swal from 'sweetalert2'
import ScanningModule from '../Utils/ScanningModule'
import SiteSelection from '../Patient/Wizard/SiteSelectionStep.vue'
import ConsentDisclaimer from '../Utils/ConsentDisclaimer.vue'
import GeneticsSection from '../Utils/GeneticsSection'
import QuestionsSection from '../Utils/QuestionsSection'
import {TranslationsUtils} from '../../../../utils/Translations'
require('cleave.js/dist/addons/cleave-phone.us')
export default {
  components: {
    [Input.name]: Input,
    [DatePicker.name]: DatePicker,
    [Autocomplete.name]: Autocomplete,
    [Drawer.name]: Drawer,
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Drawer.name]: Drawer,
    [RadioButton.name]: RadioButton,
    [CheckboxButton.name]: CheckboxButton,
    [CheckboxGroup.name]: CheckboxGroup,
    SiteSelection,
    ConsentDisclaimer,
    QuestionsSection,
    GeneticsSection,
    ScanningModule
  },
  mixins: [FormatterUtils, ValidationUtils, TranslationsUtils],
  data () {
    return {
      geneticsObject: {},
      results: {},
      error: '',
      externalIDClass: '',
      disclaimer: '',
      disabledButton: false,
      sitecode: '',
      sitecodeError: '',
      sitecodeMessage: '',
      signature: '',
      submit: false,
      reviewedSitecode: false,
      finalResponse: {},
      suggestions: [],
      answers_es: {},
      answers_zh: {},
      requirements: [],
      errorDate: '',
      errorSave: '',
      answer_no: 'No',
      fields_en: {
        employee_studentid: 'Employee/Student ID',
        submit_order: 'Submit Order',
        submitting: 'Submitting... please wait',
        next: 'Next',
        office_location_code: 'Office Location Code',
        back: 'Back',
        complete: 'Complete'
      },
      model: {
        externalID: ''
      },
      modelValidations: {
        externalID: {
          min: 2,
          required: true
        }
      }
    }
  },
  methods: {
    resetPage () {
      this.model.externalID = ''
      this.reviewedSitecode = false
    },
    redirectHome () {
      const body = document.querySelector('body')
      body.onclick = function () {
        window.location.href = window.origin + '/#/'
        window.location.reload()
      }
    },
    makeButtonDisabled () {
      this.disabledButton = true
    },
    async callValidation () {
      this.makeButtonDisabled()
      this.error = ''
      let ValidateDisclaimerConsent = await this.$refs.ConsentDisclaimer.validate()
      let geneticsSectionValidator = await this.$refs.GeneticsSection.validate()
      let sampleModuleValues = await this.$refs.scanningModule.validate()
      // call question validation
      this.questionError = this.$refs.questionSection.validate() === '' ? '' : false
      if (geneticsSectionValidator) {
        this.model.dob = this.$store.state.user.dob
        this.model.dob_pretty = this.$store.state.user.dob_pretty
      }
      if (sampleModuleValues) {
        this.model.kit_number = sampleModuleValues
      }
      this.model.questions = this.$store.state.questions
      this.signature = this.$store.state.consentSignature
      this.model.signature = this.signature
      this.submit = true
      if (this.model.externalID.length < 2 || this.model.externalID.length > 10) {
        await this.$validator.validateAll()
        if (this.$validator.errors.items.length) {
          document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
        }
        this.disabledButton = false
        return false
      } else if (ValidateDisclaimerConsent && geneticsSectionValidator && sampleModuleValues && this.questionError === '') {
        axios.post(process.env.SERVER_URI + '/self-order/' + this.$store.state.site.code, this.model)
          .then((response) => {
            if (response.data === 'data mismatch') {
              this.disabledButton = false
              this.error = 'Data mismatch, please try again'
            } else {
              let context = this
              swal({html: '<h2>Completed!</h2> <br> An email with additional details has been sent to your email',
                icon: 'success',
                width: 700,
                confirmButtonText: this.computeCaption(this.fields_en['complete'], this.$store.state.lang.value.toLowerCase()),
                confirmButtonColor: '#509119'})
                .then(function (result) {
                  window.location.assign(window.origin + '/#/')
                  window.location.reload()
                  context.disabledButton = false
                  context.error = ''
                  context.model.externalID = ''
                  context.externalIDClass = ''
                  context.reviewedSitecode = false
                  context.submit = false
                })
            }
          }).catch((error) => {
            this.disabledButton = false
            console.log(error)
          })
      } else {
        this.disabledButton = false
      }
    },
    async callSiteValidation () {
      await this.makeButtonDisabled()
      let validateSiteCode = await this.$refs.SiteSelection.validate()
      if (validateSiteCode) {
        this.disclaimer = this.$store.state.site.gopass_disclaimer
        this.reviewedSitecode = true
        this.disabledButton = false
      } else {
        this.reviewedSitecode = false
        this.disabledButton = false
      }
    },
    createFilter (queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    }
  },
  computed: {
    ...mapFields(['externalID'])
  },
  watch: {
    'reviewedSitecode': {
      handler (value) {
        this.$validator.flag('externalID', {
          touched: false,
          dirty: false,
          validated: false,
          valid: true,
          untouched: true,
          invalid: false
        })
        this.externalIDClass = ''
      }
    },
    '$store.state.allCallsDone': {
      handler (before, after) {
        this.reviewedSitecode = true
      },
      deep: true
    },
    '$store.state.invalidSiteCode': {
      handler (before, after) {
        if (this.$store.state.invalidSiteCode === true) {
          this.disabledButton = false
        }
      },
      deep: true
    },
    '$store.state.requirements': {
      handler (update) {
        delete this.$store.state.requirements['ethnicity']
        delete this.$store.state.requirements['gender']
        delete this.$store.state.requirements['race']
      },
      deep: true
    },
    'model.externalID': {
      handler (update) {
        if (this.model.externalID.length >= 2) {
          this.externalIDClass = 'validated-section-class'
        } else {
          this.externalIDClass = 'invalid-section-class'
        }
      }
    }
  },
  beforeMount () {
    this.geneticsObject = {
      model: this.$store.state.user
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../assets/sass/paper/_variables.scss";

.general-inactive-section:focus-within {
  border-left-color: $primary-color !important;
}
.green {
  background-color: $primary-color;
  position: absolute !important;
  width: 100vw !important;
  height: 100vh !important;
  left: 0 !important;
  top: 0 !important;
  z-index:10;
}
.red {
  background-color: $danger-color;
  position: absolute !important;
  width: 100vw !important;
  height: 100vh !important;
  left: 0 !important;
  top: 0 !important;
  z-index:10;
}
.white {
  color: white;
}
.text-results {
  position: absolute !important;
  text-align: center;
  width:50% !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}
.name {
  font-size:30px;
  font-weight: bold;
}
.status {
  font-size:60px;
  font-weight: bold;
}
.close-button {
  margin-left: 15px;
  font-size:30px;
  font-weight: bold;
}
.position_of_button {
  position: absolute !important;
  width:50% !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, 60vh) !important;
}
.mt-10 {
  margin-top: 10px;
}
@media  screen and (max-width: 767px) {
  .pd-mobile-10 {
    margin: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/SelfOrdering/SelfOrderingLayout.vue